import { h, Component } from 'preact'
import CountUp from './CountUp'

/** @jsx h */

const CountUpWrapper = ({ amount, ...props }) =>
  <CountUp {...props} startVal={Math.ceil(amount * 0.95)} endVal={amount} />

export default CountUpWrapper
